module.exports = "#define GLSLIFY 1\n#ifdef USE_COLOR\n\n\tvarying vec3 vColor;\n\n#endif"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/color_pars_vertex.glsl
// module id = 221
// module chunks = 0